import type { FunctionComponent } from 'react';

import CheckoutUrl from 'components/job/JobLayout/JobActions/CheckoutUrl';
import DownloadEpvsButton from 'components/job/JobLayout/JobActions/DownloadEpvsButton';
import DownloadPdfButton from 'components/job/JobLayout/JobActions/DownloadPdfButton';
import MarkJobAsCompleteButton from 'components/job/JobLayout/JobActions/MarkJobAsCompleteButton';
import MarkJobAsPaidButton from 'components/job/JobLayout/JobActions/MarkJobAsPaidButton';
import { CLASS_NAMES } from 'components/job/JobLayout/JobActions/constants';
import JobRevertButton from 'components/job/JobRevertButton';

export interface JobActionsProps {}

export const JobActions: FunctionComponent<JobActionsProps> = () => {
  return (
    <div className={CLASS_NAMES.wrapper}>
      <DownloadPdfButton />
      <CheckoutUrl />
      <DownloadEpvsButton />
      <MarkJobAsPaidButton />
      <MarkJobAsCompleteButton />
      <JobRevertButton />
    </div>
  );
};

export default JobActions;
